import Vue from 'vue'
import {
  pay,
  save,
  update,
  fetchMission,
  fetchMissions,
  getMissionProgress,
} from '@/services/mission/missionService'
import { errorMessages } from '@/util/helpers'

const state = {
  mission: {},
  missions: [],
  missionHostsProgress: [],
  isMissionLoading: false,
  isMissionSaving: false,
  isADuplication: false,
}

const getters = {
  missions: (state) => state.missions,
  mission: (state) => state.mission,
  missionHostsProgress: (state) => state.missionHostsProgress,
  isMissionLoading: (state) => state.isMissionLoading,
  isMissionSaving: (state) => state.isMissionSaving,
  isADuplication: (state) => state.isADuplication,
}

const actions = {
  async fetchMissions({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      activesOnly: false,
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await fetchMissions(params)
      const { result, total } = await data
      commit('setMissions', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async fetchMission({ commit, dispatch}, missionId) {
    commit('setIsMissionLoading', true)

    try {
      const { data } = await fetchMission(missionId)
      commit('setMission', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsMissionLoading', false)
    }
  },

  async fetchMissionHostsProgress({ commit, dispatch, rootState}, missionId) {
    commit('setIsLoading', true)

    const defaultParams = {
      missionId: missionId,
      completedFilter: false,
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await getMissionProgress(params)
      const { result, total } = await data
      commit('setMissionHostsProgress', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async payMission({ commit }, missionProgress){
    commit('setIsLoading', true)
    return pay(missionProgress)
  },

  async saveMission({ commit, dispatch }, mission) {
    commit('setIsMissionSaving', true)

    const isADuplication = state.isADuplication
    const createdMessage = Vue.i18n.translate('mission.messages.created')
    const updatedMessage = Vue.i18n.translate('mission.messages.updated')
    const duplicatedMessage = Vue.i18n.translate('mission.messages.duplicated')

    Promise.resolve(mission?.id && !isADuplication ? update(mission) : save(mission))
      .then(() => {
          commit('closeAllModals')
          dispatch('fetchMissions')

          if (isADuplication) {
            dispatch('showSuccessMessage', duplicatedMessage)
          }

          if (!isADuplication && !mission.id) {
            dispatch('showSuccessMessage', createdMessage)
          }

          if (!isADuplication && mission.id) {
            dispatch('showSuccessMessage', updatedMessage)
          }
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', errorMessages(data.errors))
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsMissionSaving', false)
        commit('setIsADuplication', false)
      })
  },

  handleOpenCreateMissionModal({ commit, dispatch }, missionId) {
    commit('setMission', null)
    commit('setIsADuplication', false)
    dispatch('openModal', 'CREATE_UPDATE_MISSION_MODAL')
    missionId && dispatch('fetchMission', missionId)
  },

  handleDuplicateMissionModal({ commit, dispatch }, missionId) {
    commit('setMission', null)
    commit('setIsADuplication', true)
    dispatch('openModal', 'CREATE_UPDATE_MISSION_MODAL')
    missionId && dispatch('fetchMission', missionId)
  }
}

const mutations = {
  setMissions: (state, missions) => {
    state.missions = missions
  },

  setMission: (state, mission) => {
    state.mission = mission
  },

  setMissionHostsProgress: (state, missionHostsProgress) => {
    state.missionHostsProgress = missionHostsProgress
  },

  setIsMissionLoading: (state, status) => {
    state.isMissionLoading = status
  },

  setIsMissionSaving: (state, status) => {
    state.isMissionSaving = status
  },

  setIsADuplication: (state, status) => {
    state.isADuplication = status
  }
}

export default {
    state,
    mutations,
    actions,
    getters,
}
